import './Indice.css';
import { useContext, useEffect, useState } from "react";
import { IndiceContext } from '../../../context/IndiceContext';
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";
import { usePreference } from "../../../context/usePreference";
import { UpdatePreferences } from '../../../services/UserService';
import { AudienceContext } from '../../../context/AudienceContext';
import { ChartContext } from '../../../context/ChartContext';
import { ChannelsContext } from '../../../context/ChannelsContext';
import { ValidAccessTokenLocalStorage, getAccessTokenLocalStorage, handleMsgError, setlsDescFullStorage } from '../../../context/utils';
import { useAuth } from "../../../context/useAuth";
import { IUserPreferenceDataRequest } from '../../../context/types';
import { getDataObjArray } from '../Sidebar/SideBarUtils';
import { DivMinuteEnum, SelectTypeGridEnum } from '../../../utils/enums';
function Indice({ pri, sec, DivMinute, selectTypeGrid }) {

    const [msgError, setMsgError] = useState<string>("");
    const [error, setError] = useState<boolean>(false);
    const { indice, doIndice } = useContext(IndiceContext)

    const { doUserPreference, userAuthenticated } = useContext(UserPreferenceContext);
    const auth = useAuth();
    const { doChannels } = useContext(ChannelsContext)
    const { doAudience, doAudienceMedia } = useContext(AudienceContext)
    const { doAudienceChart } = useContext(ChartContext);

    useEffect(() => {
        doIndice();
    }, []);

    const user = usePreference();
    let sumIndice = user.userPreference?.Indice;

    let PriDesc;
    let SecDesc;

    let combPri;
    let combSec;

    let DescFull = "";

    if (indice != undefined && sumIndice != undefined) {
        combPri = ComboPri();
        combSec = ComboSec();
    }

    function ComboPri() {
        
        let indiceObj = indice.filter(x => x.Id === sumIndice)[0];

        PriDesc = indiceObj.Desc?.split('-')[0];
        SecDesc = indiceObj.Desc?.split('-').length > 1 ? indiceObj.Desc.split('-')[1] : '-';
        if (SecDesc !== '-') {
            DescFull = PriDesc + " | " + SecDesc;
        } else {
            DescFull = PriDesc;
        }

        setlsDescFullStorage(DescFull);

        let arrayBoundPri = indice.filter(filterPriCombo).map(a => a.Desc)

        return arrayBoundPri;
    }

    function filterPriCombo(elIndice) {
        return elIndice.Desc.split('-').length == 1;
    }

    function ComboSec() {
        let arrayBoundSec = indice.filter(filterSecCombo).map(a => a.Desc.split('-')[1])
        arrayBoundSec.unshift('-')
        return arrayBoundSec;
    }

    function filterSecCombo(elIndice) {
        return elIndice.Desc.split('-').length > 1 && elIndice.Desc.split('-')[0] == PriDesc;
    }

    const TrocaPri = event => {
        let OldDesc = PriDesc;
        PriDesc = event.target.value;
        const isSecDescValid = indice.some(elIndice =>
            elIndice.Desc === (PriDesc + "-" + SecDesc)
        );
        if (OldDesc !== PriDesc) {
            if (!isSecDescValid) {
                SecDesc = '-'
            }
        }
        let newIndice = calcIndice()
        changeIndice(newIndice);
    }

    const TrocaSec = event => {
        let OldDesc = SecDesc;
        SecDesc = event.target.value;
        if (OldDesc != SecDesc) {
            let newIndice = calcIndice()
            changeIndice(newIndice);
        }
    }

    function calcIndice() {
        let newIndice = 0;
        newIndice = indice.filter(filterIndice)[0].Id;
        return newIndice;
    }


    function filterIndice(elIndice) {
        if (SecDesc == "-") {
            return elIndice.Desc == PriDesc;
        }
        else {
            return elIndice.Desc == (PriDesc + "-" + SecDesc);
        }
    }

    async function changeIndice(newIndice: number) {
        const payloadRequest: IUserPreferenceDataRequest = {
            userPreference: user.userPreference,
            indice: newIndice,
        };
        if (ValidAccessTokenLocalStorage()) {
            await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
                .catch(err => {
                    auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
                    handleMsgError(err, true, setMsgError, setError);
                });
            await doUserPreference();
            await doChannels();
            if (DivMinute === DivMinuteEnum.Media) {
                await doAudienceMedia();
            }
            else if (DivMinute === DivMinuteEnum.Analytic) {
                await doAudienceChart(60);
            }
            else {
                await doAudience();
            }
        }
    };

    return (
        <div data-testid="divIndice" className="indice-container">
            {msgError && (
                <div className="indice-error-message">
                    {msgError}
                    {error && <div className="indice-error-detail">Ocorreu um erro.</div>}
                </div>
            )}
            <div className="indice-fields-wrapper">
                <div className={`indice-field ${selectTypeGrid === SelectTypeGridEnum.Analytic ? 'indice-field-wide' : ''}`}>
                    <label className="indice-label">{pri}</label>
                    <select className='indice-select' name="comboPri" value={PriDesc} onChange={TrocaPri}>
                        {getDataObjArray(combPri).map(val => (
                            <option value={val.DataValueArray} key={val.ValueId}>
                                {val.DataValueArray}
                            </option>
                        ))}
                    </select>
                </div>
                {
                    selectTypeGrid !== SelectTypeGridEnum.Analytic && (
                        <div className='indice-field'>
                            <label className="indice-label">{sec}</label>
                            <select className='indice-select' name="comboSec" value={SecDesc} onChange={TrocaSec}>
                                {getDataObjArray(combSec).map(val => (
                                    <option value={val.DataValueArray} key={val.ValueId}>
                                        {val.DataValueArray}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default Indice;